import {createLazyFileRoute} from '@tanstack/react-router'

import AboutUs from '@/views/AboutUs/AboutUs'

export const Route = createLazyFileRoute('/about-us')({
  component: () => <AboutUs />,
})
